import React from "react";
import { Link } from "react-router-dom";
import { useAppStore } from "../../stores/appStore";
import SudowriteLogo from "../SudowriteLogo";

export function HomepageLink({ className, ...props }) {
  const { user } = useAppStore();

  if (props.children) {
    if (user) {
      return <Link to="/" className={className}>{props.children}</Link>;
    }
    return <a href="https://www.sudowrite.com" className={className}>{props.children}</a>;
  }

  return (
    <SudowriteLogo
      isLink
      size="large"
      className={className}
    />
  );
}
